import { defineCatalogue } from '../../../i18n';
import { messages as en } from './en';
import { messages as pt } from './pt-BR';

/**
 * The tenant self-serve area's own catalogue, over the shell's locale state
 * (`getLocale`/`setLocale` in `src/i18n/index.ts`). `defineCatalogue` is
 * the shell's own thin wrapper for exactly this: a feature area's key set and its
 * own `t`, without touching the shell's `src/i18n/pt-BR.ts` — see that function's
 * module doc for why three areas appending to one file is the collision the
 * route glob was built to avoid.
 *
 * pt-BR is the default, `en` is the fallback locale, matching the shell.
 */
export type TenantMessageKey = keyof typeof pt;

const catalogue = defineCatalogue(pt, en);

export function tt(key: TenantMessageKey, vars?: Record<string, string | number>): string {
  return catalogue.t(key, vars);
}
